document.addEventListener("DOMContentLoaded", function () {
    /*
    const banner = document.getElementById("Banner-template--24901806489939__image_banner_fWYa6W");
    //Banner-template--24901806489939__image_banner
    //Banner-template--24901806489939__image_banner_fWYa6W

    if (!banner) {
        //console.log("No .parallax elements found");
        return;
    }

    //Add banner to parallaxSections
    const parallaxSections = [banner];
    */
    const parallaxSections = document.querySelectorAll(".animate--parallax");

    window.addEventListener("scroll", function () {
        let i = 0;
        parallaxSections.forEach((section) => {
            const defaultSpeed = 100; //500
            const speed = parseFloat(section.getAttribute("data-speed")) || defaultSpeed;
            const image = section.querySelector("img");
            if (!image) return;

            const rect = section.getBoundingClientRect();
            const windowHeight = window.innerHeight;

            // Calculate scroll progress relative to section
            const scrollProgress = 1 - (rect.top / windowHeight);

            if(i == 0){
                //console.log("scrollProgress: " + scrollProgress);
            }

            // Clamp the scrollProgress between min and max value
            const minVal = 0;
            const maxVal = 1.5; //2
            const clamped = Math.max(minVal, Math.min(maxVal, scrollProgress));

            // Parallax translate based on section visibility, not total page scroll
            const translateY = clamped * speed;

            image.style.transform = `translateY(${translateY}px)`;

            i++;
        });
    });
  });
